
<div class="shopNavigationButtons pageActions">
  <v-btn v-if="step === 3" class="selectionButton" @click="goToStep(2)">
    <v-icon size="20">arrow_back</v-icon>
    <span class="buttonLabel fullLabel">{{ $t('BUTTON_BACK_TO_IMAGES') }}</span>
    <span class="buttonLabel shortLabel">{{ $t('ORDER_STEP_2') }}</span>
  </v-btn>
  <v-btn class="selectionButton" @click="goToStep(1)">
    <v-icon size="24">add</v-icon>
    <span class="buttonLabel">{{ $t('BUTTON_OTHER_CODE') }}</span>
  </v-btn>
  <v-btn v-if="step === 2" color="primary" @click="goToStep(3)">
    <span class="buttonLabel">{{ $t('BUTTON_CONTINUE') }}</span>
  </v-btn>
</div>
